<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-form layout="inline" style="margin-bottom: 20px">
        <a-form-item label="订单编号"><a-input v-model="query.orderNo" allow-clear @pressEnter="search" /></a-form-item>
        <a-form-item label="被投诉人"><a-input v-model="query.workerName" allow-clear @pressEnter="search" /></a-form-item>
        <a-form-item label="服务类型">
          <a-select v-model="query.serviceType" allow-clear style="width: 130px">
            <a-select-option v-for="(name, index) in services" :key="index + 1" :value="index + 1">{{ name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="处理状态">
          <a-select v-model="query.status" allow-clear style="width: 130px">
            <a-select-option v-for="(name, index) in statuses" :key="index" :value="index">{{ name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item><a-button type="primary" @click="search">查询</a-button><a-button style="margin-left: 8px" @click="reset">重置</a-button></a-form-item>
      </a-form>
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="records"
        :pagination="pagination"
        :scroll="{ x: 1200 }"
        @change="changePage">
        <template slot="serviceType" slot-scope="value">{{ services[value - 1] || '-' }}</template>
        <template slot="targetType" slot-scope="value">{{ value === 2 ? '个体户' : '师傅' }}</template>
        <template slot="status" slot-scope="value"><a-tag :color="colors[value]">{{ statuses[value] }}</a-tag></template>
        <template slot="action" slot-scope="text, record">
          <a v-hasPermi="['homeservice:complaint:query']" @click="open(record)">详情</a>
          <a v-if="record.status === 0 || record.status === 1" v-hasPermi="['homeservice:complaint:handle']" style="margin-left: 12px" @click="open(record, true)">处理</a>
        </template>
      </a-table>
    </a-card>
    <a-drawer title="服务订单投诉" :width="720" :visible="visible" @close="visible = false">
      <a-spin :spinning="detailLoading">
        <a-descriptions v-if="detail" bordered :column="2">
          <a-descriptions-item label="订单编号" :span="2">{{ detail.orderNo }}</a-descriptions-item>
          <a-descriptions-item label="服务类型">{{ services[detail.serviceType - 1] || '-' }}</a-descriptions-item>
          <a-descriptions-item label="服务名称">{{ detail.serviceName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="投诉人">{{ detail.userNickName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="投诉时间">{{ parseTime(detail.createTime) }}</a-descriptions-item>
          <a-descriptions-item label="投诉对象">{{ detail.targetType === 2 ? '个体户' : '师傅' }}：{{ detail.workerName }}</a-descriptions-item>
          <a-descriptions-item label="联系电话">{{ detail.workerMobile || '-' }}</a-descriptions-item>
          <a-descriptions-item label="投诉标题" :span="2">{{ detail.title }}</a-descriptions-item>
          <a-descriptions-item label="投诉内容" :span="2"><div style="white-space: pre-wrap">{{ detail.content }}</div></a-descriptions-item>
          <a-descriptions-item label="问题图片" :span="2">
            <a v-for="(url, index) in detail.images" :key="index" href="#" :aria-label="'放大查看投诉凭证' + (index + 1)" @click.prevent="previewImage(url)"><img :src="url" alt="投诉凭证" style="width: 90px; height: 90px; object-fit: cover; margin: 4px; cursor: zoom-in" /></a>
          </a-descriptions-item>
          <a-descriptions-item label="处理状态">{{ statuses[detail.status] }}</a-descriptions-item>
          <a-descriptions-item label="处理人">{{ detail.handler || '-' }}</a-descriptions-item>
          <a-descriptions-item label="处理时间" :span="2">{{ parseTime(detail.handleTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="处理说明" :span="2"><div style="white-space: pre-wrap">{{ detail.handleRemark || '-' }}</div></a-descriptions-item>
        </a-descriptions>
        <a-form v-if="canHandle && detail && (detail.status === 0 || detail.status === 1)" style="margin-top: 24px">
          <a-form-item label="处理状态" required>
            <a-radio-group v-model="form.status"><a-radio :value="1">处理中</a-radio><a-radio :value="2">已处理</a-radio><a-radio :value="3">已驳回</a-radio></a-radio-group>
          </a-form-item>
          <a-form-item label="处理说明" required><a-textarea v-model="form.handleRemark" :rows="5" :max-length="2000" placeholder="请填写处理过程或结果，最多2000字" /></a-form-item>
          <a-button type="primary" :loading="saving" @click="submit">提交处理</a-button>
        </a-form>
      </a-spin>
    </a-drawer>
    <a-modal
      title="问题图片预览"
      :visible="previewVisible"
      :footer="null"
      :width="900"
      :z-index="1100"
      @cancel="closePreview">
      <img v-if="previewVisible" :src="previewUrl" alt="投诉凭证大图" style="display: block; max-width: 100%; max-height: 75vh; margin: auto; object-fit: contain" />
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageComplaint, detailComplaint, handleComplaint } from '@/api/homeservice/complaint'

export default {
  name: 'HomeServiceComplaint',
  data() {
    return {
      query: { pageNum: 1, pageSize: 10 },
      records: [],
      total: 0,
      loading: false,
      detailLoading: false,
      saving: false,
      visible: false,
      previewVisible: false,
      previewUrl: '',
      canHandle: false,
      detail: null,
      form: { status: 1, handleRemark: '' },
      statuses: ['待处理', '处理中', '已处理', '已驳回'],
      colors: ['orange', 'blue', 'green', 'red'],
      services: ['上门服务', '扔垃圾', '收废品'],
      columns: [
        { title: '订单编号', dataIndex: 'orderNo', width: 190 },
        { title: '服务类型', dataIndex: 'serviceType', scopedSlots: { customRender: 'serviceType' }, width: 100 },
        { title: '投诉对象', dataIndex: 'targetType', scopedSlots: { customRender: 'targetType' }, width: 90 },
        { title: '被投诉人', dataIndex: 'workerName', width: 120 },
        { title: '投诉人', dataIndex: 'userNickName', width: 120 },
        { title: '投诉标题', dataIndex: 'title', ellipsis: true, width: 180 },
        { title: '处理状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 100 },
        { title: '投诉时间', dataIndex: 'createTime', customRender: value => this.parseTime(value), width: 170 },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 120 }
      ]
    }
  },
  computed: {
    pagination() {
      return { current: this.query.pageNum, pageSize: this.query.pageSize, total: this.total, showSizeChanger: true }
    }
  },
  created() { this.getList() },
  methods: {
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
      this.previewUrl = ''
    },
    async getList() {
      this.loading = true
      try {
        const res = await pageComplaint(this.query)
        this.records = res.data.records
        this.total = res.data.total
      } finally { this.loading = false }
    },
    search() { this.query.pageNum = 1; this.getList() },
    reset() { this.query = { pageNum: 1, pageSize: 10 }; this.getList() },
    changePage(pagination) {
      this.query.pageNum = pagination.current
      this.query.pageSize = pagination.pageSize
      this.getList()
    },
    async open(record, handle = false) {
      this.visible = true
      this.detail = null
      this.canHandle = handle
      this.detailLoading = true
      this.form = { status: 1, handleRemark: '' }
      try {
        const res = await detailComplaint({ id: record.id })
        this.detail = res.data
        this.form.handleRemark = res.data.handleRemark || ''
      } finally { this.detailLoading = false }
    },
    async submit() {
      if (!this.form.handleRemark.trim()) { this.$message.warning('请填写处理说明'); return }
      this.saving = true
      try {
        await handleComplaint({ id: this.detail.id, ...this.form })
        this.$message.success('处理成功')
        this.visible = false
        this.getList()
      } finally { this.saving = false }
    }
  }
}
</script>
